import {useEffect, useRef, useState} from "react";
import {useDispatch} from "react-redux";
import SwiperCore, {Pagination, Navigation} from "swiper";
import MobileHelperImage from "images/redbrickEvent/ForestPacours/contents_guide_mobile_forest parcours_01.png";
import PcHelperImage from "images/redbrickEvent/contents_guide_pc_01.png";
import {ACTION_TYPE} from "utils";
import View from "./View";
import {sendGameMessage} from "store/actions/game";
import {isDesktop} from "react-device-detect";

export default function Container({showReplayOption = false, dismiss}) {
  const dispatch = useDispatch();
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const firstSlideRef = useRef(null);
  const [swiper, setSwiper] = useState(null);
  const [slideHeight, setSlideHeight] = useState(firstSlideRef?.current?.clientHeight);
  SwiperCore.use([Navigation, Pagination]);

  const getHelpImg = () => {
    if (isDesktop) {
      return PcHelperImage;
    } else {
      return MobileHelperImage;
    }
  };

  const resizeScreen = () => {
    setScreenSize(window.innerWidth);
  };

  useEffect(() => {
    new ResizeObserver(() => {
      resizeScreen();
    }).observe(document.body);
  }, []);

  const onClickClose = () => {
    const joystick = document.querySelector("#joystick");
    const jumpButton = document.querySelector("#joystick_button_J");

    if (joystick) {
      joystick.style.visibility = "visible";
    }

    if (jumpButton) {
      jumpButton.style.visibility = "visible";
    }

    dispatch(
      sendGameMessage({
        type: ACTION_TYPE.SEND_GAME_MESSAGE,
        message: {type: "HELPER_CLOSE"},
      }),
    );
    dismiss();
  };

  useEffect(() => {
    handleSlideHeight();
    new ResizeObserver(() => {
      handleSlideHeight();
    }).observe(document.body);
  }, [firstSlideRef]);

  const handleSlideHeight = () => {
    setSlideHeight(firstSlideRef?.current?.clientHeight);
  };

  return (
    <View
      swiper={swiper}
      setSwiper={setSwiper}
      slideHeight={slideHeight}
      handleSlideHeight={handleSlideHeight}
      firstSlideRef={firstSlideRef}
      getHelpImg={getHelpImg}
      showReplayOption={showReplayOption}
      onClickClose={onClickClose}
      dismiss={dismiss}
    />
  );
}
